export default __webpack_public_path__ + "static/media/patty_uncooked.ae44823c.svg";